module.exports = __webpack_public_path__ + "static/media/death-of-a-phoenix-banner.144a54d3.webp";